import {Component, Input, OnInit} from '@angular/core';
import {FormFieldService} from '../../../services/form-field.service';
import {AbstractFieldComponent} from '../../abstract/abstract-field.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: []
})
export class ButtonToggleComponent extends AbstractFieldComponent implements OnInit {

  constructor(public formFieldService: FormFieldService,
              private ts: TranslateService) {
    super(formFieldService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.handleStatusChanges();
  }

  async valueLabel() {
    let valueLabel;
    if (isNotNullOrUndefined(this.control.value)) {
      if (this.fieldConfig.radioConfig) {
        const selectedOption = this.fieldConfig.radioConfig.find(radioOption => radioOption.value === this.control.value);
        valueLabel = selectedOption ? selectedOption.label : null;
      }
    }
    return valueLabel ? this.ts.instant(valueLabel) : null;
  }

}

export enum ButtonToggleSize {
  SMALL = 'SMALL',
  STANDARD = 'STANDARD',
}
